import {
  hasNoColor,
  hasNoMargin,
  hasNoSize,
  hasNoWeight,
  joinClassName
} from '../Libraries/Theme.lib';
import Typography from './Typography';

export default function Subtitle({
  children = '',
  className = '',
  style = {},
  ...props
}) {
  return (
    <Typography
      className={joinClassName([
        hasNoColor({ className, style }) && 'c-black-ligth',
        hasNoSize({ className, style }) && 'f-sm',
        hasNoMargin({ className, style }) && 'm-0',
        hasNoWeight({ className, style }) && 'fw-400',
        className
      ])}
      style={style}
    >
      {children}
    </Typography>
  )
}
